// extracted by mini-css-extract-plugin
export default {"wrapper":"success_wrapper__n2jUo","opacity-transition":"success_opacity-transition__mql5R"};